import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import SubNavigation from 'components/SubNavigation';
import SubNavigationItem from 'components/SubNavigation/SubNavigationItem';

import * as actions from 'actions';
import { getSearchTabs, getSearchTotalCounts } from 'selectors';

class SearchTabNavigation extends Component {

  constructor() {
    super();

    this.handleTabChange = this.handleTabChange.bind(this);
    this.renderSubNavigationItem = this.renderSubNavigationItem.bind(this);
  }

  handleTabChange(e, tab) {
    e.preventDefault();
    this.props.onTabChange(tab);
  }

  renderSubNavigationItem({category, title, totalCount}) {
    const { selectedTab } = this.props;
    return (
      <SubNavigationItem
        isForSearch
        key={category}
        isActive={selectedTab === category}
        onClick={(e) => this.handleTabChange(e, category)}
      >
        {title} ({totalCount})
      </SubNavigationItem>
    );
  }

  render() {
    const { magazineTotalCount, forumTotalCount } = this.props;
    const hasItems = magazineTotalCount > 0 || forumTotalCount > 0;

    const subNavItems = [
      {category: 'magazine', title: __('members.search.magazineTitle'), totalCount: magazineTotalCount},
      {category: 'forum', title: __('members.search.forumTitle'), totalCount: forumTotalCount}
    ];

    return (
      <div>
        {hasItems &&
          <SubNavigation>
            {subNavItems
                .filter(subNavItem => subNavItem.totalCount > 0)
                .map(subNavItem => this.renderSubNavigationItem(subNavItem))
            }
          </SubNavigation>
        }
      </div>
    );
  }
}

SearchTabNavigation.propTypes = {
  magazineTotalCount: PropTypes.number,
  forumTotalCount: PropTypes.number,
  isFetching: PropTypes.bool,
  selectedTab: PropTypes.string,
  onTabChange: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const { selectedTab, isFetching } = getSearchTabs(state);
  const query = { term: props.term, category: selectedTab };

  const { magazineTotalCount, forumTotalCount } = getSearchTotalCounts(state, 'results', props.term);
  return {
    selectedTab,
    isFetching,
    query,
    magazineTotalCount,
    forumTotalCount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTabChange: tab => {
      dispatch(actions.searchChangeTab(tab));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchTabNavigation);




/** WEBPACK FOOTER **
 ** ./src/members/Main/Search/SearchTabNavigation/index.js
 **/